import { apiurl, staticurl } from '../../common/constants'
import { BrandSelect } from "../subcomponents/Selectors"
import { useAuthAxios } from '../authfetch'
import { useState, useRef } from 'react'

const EditBrand = (props) => {
  const authAxios = useAuthAxios();
  const [selectedBrandId, setSelectedBrandId] = useState("");
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [currentLogo, setCurrentLogo] = useState("");
  
  const fileInputRef = useRef(null);

  const handleBrandChange = (selectedValue) => {
    setSelectedBrandId(selectedValue);
    const selectedBrandDict = props.brands.find(elem => elem._id === selectedValue);
    if (selectedBrandDict) {
      setName(selectedBrandDict.brandName);
      setDesc(selectedBrandDict.brandDesc);
      setCurrentLogo(selectedBrandDict.brandLogo);
    }
  };

  // validates input and send request to /brands :PUT
  const handleSaveEditBrandBtnClick = async (e) => {
    e.preventDefault(); 
    e.stopPropagation();

    if (!selectedBrandId || selectedBrandId === "Select Brand") {
      alert("Please select a brand first.");
      return;
    }

    const brandName = name.trim();
    const brandDesc = desc.trim();
    
    // Fallback to current logo if no new brand selected
    let brandLogo = currentLogo; 
    if (!brandLogo && selectedBrandId) {
         const found = props.brands.find(elem => elem._id === selectedBrandId);
         if(found) brandLogo = found.brandLogo;
    }

    const formData = new FormData()
    formData.append("_id", selectedBrandId)
    formData.append("brandName", brandName)
    formData.append("brandDesc", brandDesc)
    formData.append("brandLogo", brandLogo)

    // check if newbrandlogo was added
    if (fileInputRef.current && fileInputRef.current.files.length > 0) {
      formData.append("newLogo", fileInputRef.current.files[0])
    }

    const confirm = window.confirm("Are you sure you want to save changes?")
    if (!confirm) return
    
    try {
      const { data } = await authAxios.put(apiurl + "/brands", formData, {
        headers: { 
          'Content-Type': undefined, // Let browser set multipart/form-data with boundary
        }
      });
      if (data.success) {
        alert(data.message)
        props.setUpdates(prev => ({...prev, brandUpdates: prev.brandUpdates + 1}))
        if(fileInputRef.current) fileInputRef.current.value = "";
      } else {
        alert("something wrong.." + data.message)
        console.log("this is data", data)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleDeleteBrand = async () => {
    if (!selectedBrandId || selectedBrandId === "Select Brand") {
      alert("first select brand to continue")
      return
    }

    const selectedBrandDict = props.brands.find(elem => elem._id === selectedBrandId);
    if (!selectedBrandDict) return;
    
    const brandName = selectedBrandDict.brandName

    const answer = prompt(`Deleting  ${brandName} will delete all product associated with ${brandName}.Are you sure you want to delete category '${brandName}'?(yes/no)`)
    if (answer !== "yes") return
    
    try {
      const response = await authAxios.delete(apiurl + "/brands", { 
        data: { _id: selectedBrandId } 
      });
      if (response.status === 204) {
        alert("deleted " + brandName)
        props.setUpdates(prev => ({...prev, brandUpdates: prev.brandUpdates - 1}))
        // Reset state
        setSelectedBrandId("");
        setName("");
        setDesc("");
        setCurrentLogo("");
        if(fileInputRef.current) fileInputRef.current.value = "";
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      <div className="modal fade" id="editBrandModel" tabIndex="-1" aria-labelledby="editBrandLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content shadow">
            <div className="modal-header border-0 pb-0">
              <h1 className="modal-title fs-4 fw-bold heading-font" id="editCategoryLabel">Edit Brand</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body pt-4">
                <form className='editBrandForm'>
                   
                   {/* Brand Select */}
                   <div className="mb-3">
                        <label className="form-label text-muted small mb-1">Select Brand to Edit</label>
                        <BrandSelect 
                            brands={props.brands} 
                            onChange={handleBrandChange} 
                            brandId="editBrandSelect" 
                            value={selectedBrandId || ""}
                        />
                   </div>
                   
                   <div className="row g-3">
                      {/* Name */}
                      <div className="col-12">
                        <div className="form-floating">
                            <input 
                                type="text" 
                                className="form-control" 
                                id="editBrandNameInput"
                                placeholder="Renamed Brand Name" 
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required 
                                disabled={!selectedBrandId}
                            />
                            <label htmlFor="editBrandNameInput">Brand Name</label>
                        </div>
                      </div>

                      {/* Description */}
                      <div className="col-12">
                        <div className="form-floating">
                             <textarea 
                                required 
                                className="form-control" 
                                id="editBrandDescInput"
                                placeholder='Brand Description' 
                                style={{ height: "120px" }}
                                value={desc}
                                onChange={(e) => setDesc(e.target.value)}
                                disabled={!selectedBrandId}
                             ></textarea>
                             <label htmlFor="editBrandDescInput">Description</label>
                        </div>
                      </div>
                   </div>

                   {/* Image Section */}
                   {selectedBrandId && (
                       <div className="mt-4 border rounded p-3 bg-light">
                            <label className="form-label fw-bold">Brand Logo</label>
                            <div className="d-flex align-items-center gap-4">
                                <div className="text-center">
                                    <p className="text-muted small mb-1">Current</p>
                                    <div className="bg-white p-2 border rounded">
                                        <img 
                                            src={currentLogo ? (staticurl + currentLogo) : '#'} 
                                            className='img-fluid' 
                                            style={{ height: "60px", objectFit: 'contain' }} 
                                            alt="Current Logo" 
                                        />
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                     <label htmlFor="editBrandImage" className="form-label small">Change Logo (Optional)</label>
                                     <input 
                                        className="form-control" 
                                        type="file" 
                                        accept="image/*" 
                                        id="editBrandImage" 
                                        ref={fileInputRef}
                                     />
                                </div>
                            </div>
                       </div>
                   )}
                   
                   {/* Footer Actions */}
                   <div className="d-flex justify-content-between mt-4 border-top pt-3">
                      <button 
                        type="button" 
                        id="deleteBrandBtn" 
                        className="btn btn-outline-danger" 
                        onClick={handleDeleteBrand}
                        disabled={!selectedBrandId}
                      >
                          <i className="fa-solid fa-trash-can me-2"></i> Delete Brand
                      </button>
                      <button 
                        type="button"
                        onClick={handleSaveEditBrandBtnClick} 
                        id="editBrandBtn" 
                        className="btn btn-dark px-4"
                        disabled={!selectedBrandId}
                      >
                          <i className="fa-solid fa-floppy-disk me-2"></i> Save Changes
                      </button>
                    </div>

                </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditBrand;
